import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { CitoApplicationModule } from "../model/model";
import { UserService } from "../services/user.service";

export class SetModuleAction {
  public static readonly type = "[Dashboard] set Module";
  constructor(public payload: CitoApplicationModule) {}
}

export class SetModuleChosenAction {
  public static readonly type = "[Dashboard] set Module Chosen";
  constructor(public payload: boolean) {}
}

export interface DashboardStateModel {
  moduleChosen: boolean;
  module: CitoApplicationModule;
}

@State<DashboardStateModel>({
  name: "dashboard",
  defaults: {
    moduleChosen: false,
    module: CitoApplicationModule.Rekenen,
  },
})
@Injectable()
export class DashboardState {
  constructor(private userService: UserService) {}

  @Selector()
  static getState(state: DashboardStateModel) {
    return state;
  }

  @Selector()
  static citomodule(state: DashboardStateModel) {
    return state.module;
  }

  @Action(SetModuleAction)
  setModule(ctx: StateContext<DashboardStateModel>, action: SetModuleAction) {
    sessionStorage.setItem(
      `${this.userService.user.id}-citomodule`,
      action.payload.toString()
    );
    ctx.patchState({ module: action.payload });
  }

  @Action(SetModuleChosenAction)
  setModuleChosen(
    ctx: StateContext<DashboardStateModel>,
    action: SetModuleChosenAction
  ) {
    ctx.patchState({ moduleChosen: action.payload });
  }
}
